import { useEffect, useState, MutableRefObject } from "react";

export function useFeed(url: string): FeedResponse {
    const [feed, setFeed] = useState<Array<Item>>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (!url) {
            setIsLoading(true);
            setFeed([]);
            return;
        }
        setIsLoading(true);
        setFeed([]);
        /*const options = {
            method: 'POST',
            body: JSON.stringify({
                url
            })
        }*/
        fetch(url)
            .then(r => r.text())
            .then(str => {
                return new DOMParser().parseFromString(str, 'text/xml')
            })
            .then(data => {
                try {
                    const feed = getRSSData(data)
                        .sort((a: Item, b: Item) => b.pubDate.getTime() -
                            a.pubDate.getTime())
                    setFeed(feed)
                } catch (e) {
                    console.error(e);
                }
            })
            .catch(setError)
            .finally(() => {
                setIsLoading(false);
            })
    }, [url]);
    return {
        feed,
        isLoading,
        error
    }
}

interface FeedResponse {
    feed: Array<Item>
    error: Error | null;
    isLoading: boolean
}

function getRSSData(data: Document): Array<Item> {
    const channel = getChannel(data);
    if (!channel) {
        return [];
    }
    return getItems(channel.childNodes);
}

function getChannel(data: Document): Node | null {
    const channel = data.childNodes[0].childNodes as NodeList;
    for (const item of channel.values()) {
        if (item.nodeName === 'channel') {
            return item;
        }
    }
    return null;
}

function getItems(nodes: NodeList): Array<Item> {
    const items = [];
    for (const item of nodes.values()) {
        if (item.nodeName === 'item') {
            items.push(getItem(item));
        }
    }
    return items;
}

function getItem(item: Node): Item {
    const nodes = toArray(item.childNodes.values())
    const title = getTextContent(nodes, 'title');
    const link = getTextContent(nodes, 'link')
    const category = getTextContent(nodes, 'category')
    const creator = getTextContent(nodes, 'dc:creator');
    const thumbnail = getThumbnail(nodes, 'media:thumbnail')
    const description = getTextContent(nodes, 'description');
    const pubDate = new Date(`${getTextContent(nodes, 'pubDate')}`)
    return {
        title,
        link,
        creator,
        description,
        thumbnail,
        category,
        pubDate
    };
}

export interface Item {
    title: string | null;
    link: string | null;
    creator: string | null;
    thumbnail: string | null;
    category: string | null;
    description: any;
    pubDate: Date;
    index?: number;
}

function getTextContent(nodes: Array<ChildNode>, tag: string) {
    if (!nodes?.length) {
        return null;
    }
    const filteredNode: Array<any> = nodes.filter(n => n.nodeName === tag);
    if (!filteredNode.length) {
        return null;
    }
    return filteredNode[0].textContent;
}

function getThumbnail(nodes: Array<ChildNode>, tag: string): string | null {
    const filteredNode: Array<any> = nodes.filter(n => n.nodeName === tag);
    if (!filteredNode.length) {
        return null;
    }
    const thumbnail = filteredNode[0]
    if (!thumbnail?.attributes?.url) {
        return null
    }

    const { value } = thumbnail.attributes.url;
    return value;
}

function toArray(nodes: IterableIterator<ChildNode>): Array<ChildNode> {
    const response = [];
    for (const node of nodes) {
        response.push(node);
    }
    return response;
}

export function useRevolveAd(ref: MutableRefObject<any>) {
    useEffect(() => {
        if (!ref) {
            return;
        }
        if (!ref.current) {
            return
        }
        const { current } = ref;
        for (const item of current.children) {
            if (item.localName === 'script') {
                current.removeChild(item)
            }
        }

        const tag = document.createElement('script');
        tag.src = `https://fast.poets-writers.org/openx/www/delivery/asyncjs.php?id=${Math.random()}`;
        tag.async = true;
        tag.onload = () => {
            setTimeout(() => {
                const w: any = window;
                if (w.reviveAsync) {
                    delete w.reviveAsync;
                }
            }, 1000);
        }
        ref.current.appendChild(tag);
        setTimeout(() => {
            for (const item of current.children) {
                if (item.localName === 'script') {
                    current.removeChild(item)
                }
            }
        }, 1500)
    }, [ref])
}